/* eslint-disable */
import {
  Flex,
  Form,
  Input,
  Checkbox,
  Modal,
  Select,
  Table,
  Space,
  Button,
  Tooltip,
  Radio,
  message,
  Popover,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
} from "react";
import {
  CaretDownOutlined,
  MailOutlined,
  OneToOneOutlined,
  CheckOutlined,
  CloseOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.css";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { useLocation } from "react-router-dom";
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);

  const initTableHead = {
    propUnit: null,
    vendorName: null,
    jobType: null,
    payAmount: null,
    predictCompletionTime: null,
    requestDate: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: "#",
      dataIndex: '#',
      width:50,
    },
    {
      titleType: 'Input',
      title: 'Prop Unit',
      dataIndex: "propUnit",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'propUnit'),
    },
    {
      titleType: 'Input',
      title: 'Vendor Name',
      dataIndex: "vendorName",
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName')
    },
    {
      titleType: 'Input',
      title: 'Job Type',
      dataIndex: "jobType",
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'jobType')
    },
    {
      titleType: 'Input',
      title: 'Pay Amount',
      dataIndex: "payAmount",
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'payAmount'),
      isAmountFlag: true
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    // {
    //   titleType: 'DatePicker',
    //   title: 'Predict Completion Time',
    //   dataIndex: "predictCompletionTime",
    //   isSorter: false,
    //   onChange: (e) => tableFilterFn(e, 'predictCompletionTime', 'DatePicker'),
    // },
    {
      titleType: 'DatePicker',
      title: 'Request Date',
      dataIndex: "requestDate",
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'requestDate', 'DatePicker'),
    },
  ]

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      page: current || pagination.current ,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
    };

    const response = await http.get(api.getApprovalMaintenanceList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
  
  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const [btnLoading, setBtnLoading] = useState(false);
  
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    // 验证表单
    const values = await approvalForm.validateFields();
    
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };

  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }


  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('DetailDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnAgreed" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnRefused" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('Rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnAmount" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.payAmount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollX={undefined}
        tableScrollY="350px"
        tableCss="maintenanceTable"
      />

      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        maskClosable={false}
        open={openApproval}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item>

          {approvedOrRejected !=='Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item>}
        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;
